import React from 'react'
import { Tabs, Tab, Grid } from '@material-ui/core'
import { useLocation, Link } from 'react-router-dom'
import clsx from 'clsx'
import { TabsProps } from './Type'
import { useStyle } from './Style'

export const NavTabs: React.FC<TabsProps> = ({
  items,
  onChange,
  value,
  withContainer,
  autoWidth,
  withScroll,
}): React.ReactElement => {
  const classes = useStyle()
  const location = useLocation()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleChange = (_e: any, v: any) => {
    if (onChange) {
      onChange(_e, v)
    }
  }

  const isValue = () => {
    if (value || value === 0) {
      return value
    }
    return location.pathname
  }

  const innerContent = () => (
    <Tabs
      value={isValue()}
      indicatorColor="primary"
      textColor="primary"
      onChange={handleChange}
      // className="navigationTabs"
      className={clsx('navigationTabs', withScroll && classes.containerScroll)}
      data-cy="navigationTabs"
      variant={withScroll ? 'scrollable' : undefined}
      scrollButtons={withScroll ? 'auto' : undefined}
    >
      {items.map((el, i) =>
        el.path ? (
          <Tab
            key={`tab-${i}`}
            label={el.label}
            value={el.path}
            component={Link}
            data-cy="navigationTabs__item"
            className={clsx(classes.el, autoWidth && classes.elAutoWidth)}
            disabled={el.disable}
            to={{
              pathname: el.path,
              search: location.search,
            }}
          />
        ) : (
          <Tab
            key={`tab-${i}`}
            label={el.label}
            value={el.activeValue}
            data-cy="navigationTabs__item"
            className={clsx(classes.el, autoWidth && classes.elAutoWidth)}
            disabled={el.disable}
          />
        )
      )}
    </Tabs>
  )
  return withContainer ? (
    <Grid container className={classes.container}>
      {innerContent()}
    </Grid>
  ) : (
    innerContent()
  )
}

export default NavTabs
